<ng-container *ngIf="lesson && (activities$ | async) as activities;else loadingData">
    <div class="header">
        <ng-container *ngTemplateOutlet="headerTemplate; context: {$implicit: lesson}"></ng-container>
    </div>
    <div class="content">
        <ng-container *ngFor="let activity of activities$ | async; let index = index">
            <ng-container
                *ngTemplateOutlet="activityTemplate; context: {activity, index: lessonIndex + '_' + index}"></ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #loadingData>
    <mat-spinner
        style="position:relative; display: flex; justify-content: center; align-items: center; height: 100%;"></mat-spinner>
</ng-template>



